<div class="identialert-sub-selection-wrapper">
  <div class="identialert-modal-title">
    Choose an identialert subscription type
  </div>

  <div class="identialert-sub-type-selector-wrapper">
    <div>
      <button
        class="btn btn-link btn-lg text-dark p-0 pricing-font d-flex"
        (click)="planIdIdentiAlert = pricingPlans.identiAlertAnnual">
        <fa-icon
          [icon]="['far', planIdIdentiAlert === pricingPlans.identiAlertAnnual ? 'check-square' : 'square']"
          class="me-2">
        </fa-icon>
        £36 <span class="pricing-font-description">/ year</span>
      </button>
    </div>
    <div class="mt-2">
      <button
        class="btn btn-link btn-lg text-dark p-0 pricing-font d-flex"
        (click)="planIdIdentiAlert = pricingPlans.identiAlertMonthly">
        <fa-icon
          [icon]="['far', planIdIdentiAlert === pricingPlans.identiAlertMonthly ? 'check-square' : 'square']"
          class="me-2">
        </fa-icon>
        £4.99 <span class="pricing-font-description">/ month</span>
      </button>
    </div>
  </div>

  <div class="button-wrapper">
    <button class="btn close-modal-button me-2" (click)="onCloseModal()" [disabled]="loading">Cancel</button>
    <button class="btn btn-secondary text-white" (click)="onSubscribeToIdentiAlert()" [disabled]="loading">
      <fa-icon *ngIf="loading" [icon]="['fas', 'spinner']" [animation]="'spin'" class="me-3"></fa-icon>
      Subscribe
    </button>
  </div>
</div>
